import React from 'react'
import { Link } from 'react-router-dom'
import { useTheme } from '../Context/ThemeContext';


function HeaderItem({ title, number, route }) {

    const { primaryColor, secondaryColor, setShowSidebar } = useTheme();

    return (
        <div className='font-bold mx-2'>
            <Link to={route} onClick={() => setShowSidebar(false)}>
                <span className={`mx-2 ${primaryColor}`}>{number}</span>
                <span className={`${secondaryColor} hover:${primaryColor}`}>{title}</span>
            </Link>
        </div>
    )
}

export default HeaderItem